module.exports = __webpack_public_path__ + "media/images/graphwear-logo-54a986b0.png";